// DevHub: compact EN/DE language switcher for the header. Drives Backstage's
// appLanguageApiRef (the single source of truth; persisted), which flips both
// custom chrome and core pages. Extracted from Root.tsx.
import { useEffect, useState } from 'react';
import { useApi } from '@backstage/core-plugin-api';
import { appLanguageApiRef, useTranslationRef } from '@backstage/core-plugin-api/alpha';
import { commonMessages } from '../../i18n/common';

export function LanguageSwitcher() {
  const languageApi = useApi(appLanguageApiRef);
  const { t } = useTranslationRef(commonMessages);
  const [lang, setLang] = useState(() => languageApi.getLanguage().language);

  useEffect(() => {
    const sub = languageApi.language$().subscribe(next => setLang(next.language));
    return () => sub.unsubscribe();
  }, [languageApi]);

  const toggle = () => languageApi.setLanguage(lang === 'de' ? 'en' : 'de');
  return (
    <odx-button
      variant="ghost"
      // `class`, NOT `className`: React 18 does not reflect className onto a custom
      // element, so this rendered `classname="devhub-lang-switch"` and the
      // .devhub-lang-switch rules in Root.css never applied (same bug as
      // .devhub-search-trigger in Root.tsx). See odx.d.ts.
      class="devhub-lang-switch"
      type="button"
      onClick={toggle}
      title={t('language.label')}
      aria-label={t('language.label')}
    >
      <odx-icon slot="prefix" className="odx-icon" name="core::globe" size="sm" />
      <span className="devhub-lang-switch__code">{lang === 'de' ? 'DE' : 'EN'}</span>
    </odx-button>
  );
}
